
<modal-window :main-width="12">
  <div v-if="loading" class="text-center">
    <loading-spinner></loading-spinner>
  </div>
  <div v-if="!loading">
    <h2>Active Schedules</h2>
    <div class="schedules-list">
      <table class="table table-striped">
        <thead>
          <tr>
            <th style="width: 64%">Name</th>
            <th style="width: 10%; text-align: center">Timezone</th>
            <th style="width: 10%; text-align: center">Planned</th>
            <th style="width: 10%; text-align: center">Due</th>
            <th style="width: 18%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="templateSchedules.length === 0">
            <td colspan="5">
              <i class="far fa-info-circle"></i>
              &nbsp; No Schedules defined
            </td>
          </tr>

          <tr v-for="schedule in templateSchedules" :key="schedule.id">
            <td>{{ schedule.description }}</td>
            <td style="text-align: center" class="text-nowrap">
              <div v-if="schedule.scheduleType === 'Date' && !schedule.cronExpressionIsLocalTime" class="badge badge-primary">UTC</div>
              <div v-if="schedule.scheduleType === 'Date' && schedule.cronExpressionIsLocalTime" class="badge badge-secondary">LOCAL</div>
            </td>
            <td class="text-center">
              <div class="badge badge-primary" v-if="schedule.plannedMinutesAfterCreation">
                <i class="far fa-clock"></i>
                {{ schedule.plannedMinutesAfterCreation }} mins
              </div>
              <div v-else class="badge badge-secondary">N/A</div>
            </td>
            <td class="text-center">
              <div class="badge badge-primary" v-if="schedule.dueMinutesAfterCreation">
                <i class="far fa-clock"></i>
                {{ schedule.dueMinutesAfterCreation }} mins
              </div>
              <div v-else class="badge badge-secondary">N/A</div>
            </td>
            <td>
              <div class="badgebutton danger active text-center text-nowrap" @click="confirmDeleteSchedule(schedule.id)">
                <i class="far fa-trash mr-1"></i>
                Delete
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2>Add Schedule</h2>
    <hr />

    <div class="label mb-2">Schedule Type</div>
    <b-form-group>
      <b-form-radio-group v-model="newSchedule.scheduleType" name="radio">
        <b-form-radio name="option" :value="boardItemScheduleType.Date">Date</b-form-radio>
        <b-form-radio name="option" :value="boardItemScheduleType.ShiftStart">At Shift handover</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <template v-if="isScheduleTypeDateSelected">
      <label class="label mb-2">Specify time interval</label>
      <section v-on:click="isMonthlySelected">
        <vue-cron-editor :visibleTabs="cronTabs" :cronSyntax="'quartz'" v-model="newSchedule.cronExpression" id="schedule-cron-editor">
          <template>fddfdfdf</template>
        </vue-cron-editor>
      </section>

      <div v-if="isMonthlySelectedState" class="pl-3 pr-3 col-4 mb-3">
        <div class="label mb-2">Starting in</div>
        <select class="form-control form-control-sm" v-model="monthlyStartingAt">
          <option :value="null">Select start month</option>
          <option v-for="option in monthlyStartingAtOptions" :value="option.id" :key="option.id">{{ option.name }}</option>
        </select>
      </div>

      <b-form-checkbox class="ml-4 mb-1" v-model="newSchedule.cronExpressionIsLocalTime" :unchecked-value="false">
        Local Time
      </b-form-checkbox>
    </template>

    <template v-else>
      <div class="label mb-2">Specify Shift</div>
      <select class="form-control form-control-sm" v-model="newSchedule.shiftTypeId">
        <option :value="null">All shifts</option>
        <option v-for="option in shiftTypeOptions" :value="option.id" :key="option.id">{{ option.name }}</option>
      </select>
    </template>

    <hr />
    <label class="label mb-2">
      Advanced Settings
      <i class="far fa-info-circle" v-b-tooltip title="0 means no planned/ due date will be set for the newly created item"></i>
    </label>
    <div class="row">
      <div class="col-6">
        <div class="label">Planned</div>
        <div class="input-group input-group-sm mb-3">
          <input type="number" class="form-control form-control-sm" placeholder="" v-model="newSchedule.plannedMinutesAfterCreation" />
          <div class="input-group-append">
            <div class="input-group-text input-gr">minutes after creation</div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="label">Due</div>
        <div class="input-group input-group-sm mb-3">
          <input type="number" class="form-control form-control-sm" placeholder="" v-model="newSchedule.dueMinutesAfterCreation" />
          <div class="input-group-append">
            <div class="input-group-text input-gr">minutes after creation</div>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <div class="action-bar d-flex justify-content-end">
      <b-alert show variant="info" v-if="warningMessage" class="mr-2" @click.native="clearWarning()">
        <i class="far fa-exclamation-triangle"></i>
        &nbsp;
        {{ warningMessage }}
      </b-alert>
      <button class="badgebutton success active text-center" @click="addSchedule()" :disabled="!isScheduleDataValid">
        <i class="far fa-plus"></i>
        Add Schedule
      </button>
    </div>
  </div>
</modal-window>
